<template>
	<div class="ui basic active tab">
		<div class="ui">
			<h1 class="header">
				{{ $t('pages.payments.header') }}
			</h1>
		</div>
		<div class="ui divider"></div>

		<div class="ui two column stackable grid">
			<div class="six wide column">
				<div class="ui segment">
					<h3 class="header">{{ $t('pages.payments.filter.header', {merchantname: activeMerchant.name}) }}</h3>
					<div class="ui clearing divider"></div>
					{{ $t('pages.payments.filter.description') }}
				</div>
			</div>
			<div class="ten wide column">
				<div class="ui pointing secondary tabular menu">
					<div class="item" :class="{ 'active' : currentTab === 0 }" @click="currentTab = 0">{{ $t('pages.payments.payment.processed') }}</div>
					<div class="item" :class="{ 'active' : currentTab === 1 }" @click="currentTab = 1">{{ $t('pages.payments.payment.upcoming') }}</div>
				</div>

				<div class="ui bottom active tab basic" v-if="currentTab === 0" :class="{ 'loading': processedLoader }" v-cloak>
					<div class="ui segments" v-if="processedTransactions.data.length > 0">
						<transaction v-for="processedTransaction in processedTransactions.data" :amount="processedTransaction.amount" :transaction="processedTransaction" :key="processedTransaction.id"></transaction>
					</div>
					<div v-else>
						<div class="ui centered aligned icon header">
							<i class="close icon"/>
							{{ $t('pages.payments.payment.error.noprocessedfound') }}
						</div>
					</div>

					<div v-if="processedTransactions.last_page > 1">
						<div class="ui pagination menu" v-if="processedTransactions.last_page <= 5">
							<a class="item" v-for="amount in processedTransactions.last_page" :class="{ 'active' : amount === currentProcessedPage }" @click="currentProcessedPage = amount">
								{{ amount }}
							</a>
						</div>
						<div class="ui pagination menu" v-else>
							<a class="icon item" @click="currentProcessedPage--" v-if="currentProcessedPage > 1">
								<i class="angle left icon"/>
							</a>
							<a class="item">{{ currentProcessedPage }}</a>
							<a class="icon item" @click="currentProcessedPage++" v-if="currentProcessedPage !== processedTransactions.last_page">
								<i class="angle right icon"/>
							</a>
						</div>
					</div>
				</div>

				<div class="ui bottom active tab basic" v-if="currentTab === 1" :class="{ 'loading' : upcomingLoader }" v-cloak>
					<div class="ui segments" v-if="upcomingTransactions.data.length > 0">
						<upcoming-transaction v-for="upcomingTransaction in upcomingTransactions.data" :subscriptionid="upcomingTransaction.id" :key="upcomingTransaction.id"></upcoming-transaction>
					</div>
					<div v-else>
						<div class="ui centered aligned icon header">
							<i class="close icon"/>
							{{ $t('pages.payments.payment.error.noupcomingfound') }}
						</div>
					</div>
					<div v-if="upcomingTransactions.last_page > 1">
						<div class="ui pagination menu" v-if="upcomingTransactions.last_page <= 5">
							<a class="item" v-for="amount in upcomingTransactions.last_page" :key="amount" :class="{ 'active' : amount === currentUpcomingPage }" @click="currentUpcomingPage = amount">
								{{ amount }}
							</a>
						</div>
						<div class="ui pagination menu" v-else>
							<a class="icon item" @click="currentUpcomingPage--" v-if="currentUpcomingPage > 1">
								<i class="angle left icon"/>
							</a>
							<a class="item">{{ currentUpcomingPage }}</a>
							<a class="icon item" @click="currentUpcomingPage++" v-if="currentUpcomingPage !== upcomingTransactions.last_page">
								<i class="angle right icon"/>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Payments',

		data () {
			return {
				currentTab: 1,

				processedTransactions: {
					data: []
				},
				currentProcessedPage: 1,
				processedLoader: false,

				upcomingTransactions: {
					data: []
				},
				currentUpcomingPage: 1,
				upcomingLoader: false
			}
		},

		watch: {
			activeMerchant: function () {
				this.fetchProcessedTransactions()
				this.fetchUpcomingTransactions()
			},

			currentUpcomingPage: function () {
				this.fetchUpcomingTransactions()
			},

			currentProcessedPage: function () {
				this.fetchProcessedTransactions()
			}
		},

		mounted () {
			this.fetchProcessedTransactions()
			this.fetchUpcomingTransactions()
		},

		methods: {
			fetchProcessedTransactions () {
				this.processedLoader = true
				this.axios.get(`merchants/me/${this.activeMerchant.id}/transactions`, {
					params: {
						perPage: 5,
						page: this.currentProcessedPage
					}
				})
				.then(({data}) => {
					this.processedTransactions = data
					this.processedLoader = false
				}).catch(() => {
					this.processedLoader = false
				})
			},

			fetchUpcomingTransactions () {
				this.upcomingLoader = true
				this.axios.get(`merchants/${this.activeMerchant.id}/subscriptions`, {
					params: {
						perPage: 5,
						page: this.currentUpcomingPage,
						filter: 'active|delayed'
					}
				})
				.then(({data}) => {
					this.upcomingTransactions = data

          var filteredTransactions = data.data.filter((currentValue, index) => {
            if (currentValue.pricing.type === 'instant') {
              if (currentValue.transactions.length > 0) {
                let showInstant = true
                currentValue.transactions.forEach((value, index) => {
                  if (value.status === 'success') {
                    showInstant = false
                  }
                })

                if (showInstant) {
                  return currentValue
                }
              } else {
                return currentValue
              }
            } else {
              return currentValue
            }
          })
          this.upcomingTransactions.data = filteredTransactions

					this.upcomingLoader = false
				}).catch(() => {
					this.upcomingLoader = false
				})
			}
		},

		computed: {
			activeMerchant () {
				return this.$store.getters.activeMerchant
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/merchant/Payments.vue